import { IReportRequest, PeekdataError } from 'peekdata-datagateway-api-sdk';
import { put, select, takeLatest } from 'redux-saga/effects';
import { routes } from 'src/constants/routes';
import { storage } from 'src/constants/storage';
import { IReport } from 'src/models/report';
import { IAppState } from 'src/models/state';
import { reportsApi } from 'src/services/api';
import { IAction } from 'src/state/action';
import { actionTypes, closeModal, reportLoaded, reportSaved } from 'src/state/report/actions';
import { IReportState } from 'src/state/report/reducer';

function* onLoadReport(action: IAction<string>) {
  try {
    const reportId = action.payload;

    if (!reportId) {
      yield put(reportLoaded({
        data: null,
        isFetching: false,
        error: null,
        errorTimestamp: null,
      }));

      return;
    }

    const sessionID = localStorage.getItem(storage.sessionIdKey);
    const report: IReport = yield reportsApi.getReport(sessionID, reportId);

    yield put(reportLoaded({
      data: report,
      isFetching: false,
      error: null,
      errorTimestamp: null,
    }));
  } catch (error) {
    yield put(reportLoaded({
      data: null,
      isFetching: false,
      error: error.toString(),
      errorTimestamp: new Date(),
    }));
  }
}

function* onSaveReport(action: IAction<IReportRequest>) {
  const reportState: IReportState = yield select((state: IAppState) => state.report);
  const { report, reportTitle } = reportState;
  const reportData = report && report.data;

  try {
    const request = action.payload;
    const sessionID = localStorage.getItem(storage.sessionIdKey);

    if (!reportTitle.replace(/[^\w\s]/gi, '')) {
      throw new PeekdataError('Report\'s title cannot be blank', null);
    }

    const savedReport: IReport = yield reportsApi.saveReport(sessionID, {
      reportID: reportData && reportData.reportID ? reportData.reportID : '',
      created: reportData && reportData.created ? reportData.created : null,
      title: reportTitle,
      dataRequest: request,
    });

    updateLocation(savedReport);

    yield put(reportSaved({
      data: savedReport,
      isFetching: false,
      error: null,
      errorTimestamp: null,
    }));

    yield put(closeModal());
  } catch (error) {
    yield put(reportSaved({
      data: reportData,
      isFetching: false,
      error: error.toString(),
      errorTimestamp: new Date(),
    }));
  }
}

// #region -------------- Helpers -------------------------------------------------------------------

const updateLocation = (savedReport: IReport) => {
  try {
    const report = savedReport;
    const { reportID } = report;

    window.history.replaceState({ reportID }, reportID, `${routes.report}/${reportID}`);
  } catch (error) { }
};

// #endregion

export const reportSaga = [
  takeLatest(actionTypes.loadReport, onLoadReport),
  takeLatest(actionTypes.saveReport, onSaveReport),
];
